.m{display:inline-flex;}